import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { } from 'jquery';
declare var $;
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { debounceTime,distinctUntilChanged,map,filter } from 'rxjs/operators';

import { ConstantComponent } from '../../../constant.component';
import { headerService } from './header.service';
import { AppError } from 'app/GenericService/app-error';
import { CommanService } from 'app/shared/comman/comman.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [headerService]
})

export class HeaderComponent implements OnInit {

    showForgotpassSuccess = false;
    showForgotpassError = false;
    isFromForgotPasswordScreen = false;

usernameLogged:string
UserRoleName:string
UserId:any;
ModuleDetailsId:any;
subscriberNameLogged : string
SAMenu:boolean = true
mainterMenu:boolean = true
companyName:string
maintenanceData:any = []
maintenance:any = {}   
errorText:any 
totalFOE:any = []
totalFleet:any = []
IsSuperAdmin:boolean = false;
IsFOEVisible:boolean=true;
IsFleetScoreVisible:boolean=true;
gotoService:any;
constructor(private service: headerService,public router: Router,private modalService: NgbModal,private http: Http,private comman:CommanService) {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd && window.innerWidth <= 992) {
                this.toggleSidebar();
            }
        });
    }

    mouseover(e,route, serviceName,moduleId) {
        let redirectionUrl = ""
        ConstantComponent.IframesOfServices.forEach((s: any) => {
            if (s.service == serviceName) {
                redirectionUrl = `${s.FE_Url}${route}`;
                redirectionUrl = redirectionUrl+"?ModuleId="+moduleId;
                e.target.setAttribute("href",redirectionUrl)
                return;
            }
        });
    }

    ngOnInit() {
        this.gotoService = this.comman.gotoService;
        this.os_dropdown()

        this.ModuleDetailsId = localStorage.getItem('ModuleId')

        console.log(localStorage.getItem('ModuleId'))
        if(this.ModuleDetailsId == 0)
        {
            this.ModuleDetailsId = 0; 
        }
        else if(this.ModuleDetailsId != 0)
        {
            
            this.ModuleDetailsId = 1; 
        }
        if(ConstantComponent.subscriberIdLogged==0){
            this.IsSuperAdmin=true;
        }
        else{
          this.IsSuperAdmin=false;
        }             
        if(ConstantComponent.BuConfig!=null){
            let buConfigFoe = ConstantComponent.BuConfig.filter(x=>x.buConfigId==2)
            if(buConfigFoe!=null){
                if(buConfigFoe.length>0){
                    if(buConfigFoe[0].configValue.toLowerCase()=="true"){
                        this.IsFOEVisible = false;
                    }
                }
               
            }   
            let buConfigFleet = ConstantComponent.BuConfig.filter(x=>x.buConfigId==3)
            if(buConfigFleet!=null){
                if(buConfigFleet.length>0){
                    if(buConfigFleet[0].configValue.toLowerCase()=="true"){
                        this.IsFleetScoreVisible = false;
                    }
                }           
            }   
        }
  console.log(localStorage.getItem('userIdLogged'))
       this.UserId = localStorage.getItem('userIdLogged')
        this.usernameLogged = localStorage.getItem('usernameLogged')
        this.UserRoleName= localStorage.getItem('UserRoleName')
        this.companyName=localStorage.getItem('companyName')
        this.subscriberNameLogged = localStorage.getItem('subscriberNameLogged')
        if (localStorage.getItem('SuperAdminRights')) {
            this.SAMenu = false
            this.mainterMenu = true
        } else if (localStorage.getItem('MaintainerRights')) {
            this.mainterMenu = false
            this.SAMenu = true
        }  else {
            this.SAMenu = true
            this.mainterMenu = true
        }
        // this.service.get(ConstantComponent.url + "/MaintenanceAPI/GetDetailsById/?UserId="+ ConstantComponent.userIdLogged +"&UserSessionId="+ConstantComponent.UserSessionId+"&FormId=0&IpAddress="+ConstantComponent.IpAddress+"&BrowserName="+ConstantComponent.BrowserName+"&BrowserVersion="+ConstantComponent.BrowserVersion).subscribe(data => {
        //     console.log(data)
        //     this.maintenance=data
        //     if (data != null) {
        //         var current = new Date();
        //         var nums = this.maintenance.endTime.split(':');
        //         var currentTime = (current.getHours() * 60 * 60 * 1000) + (current.getMinutes() * 60 * 1000)
        //         var endTime = (parseInt(nums[0]) * 60 * 60 * 1000) + (parseInt(nums[1]) * 60 * 1000);
        //         var currentDate = this.setDate("");
        //         var maintenanceDate = this.setDate(this.maintenance.date)
        //         if(currentDate == maintenanceDate) {
        //             if(currentTime > endTime) {
        //                 this.service.get(ConstantComponent.url + '/MaintenanceAPI/StopService').subscribe(data => {
        //                         console.log(data)
        //                         this.maintenanceData = []
        //                     },
        //                     error => {
        //                     // bootbox.alert("Something went wrong! Please try again")
        //                     }
        //                 );
        //             } else {
        //                 this.maintenanceData.push(data)
        //                 this.maintenanceData[0].startTime = this.convertTime(this.maintenance.startTime)
        //                 this.maintenanceData[0].endTime = this.convertTime(this.maintenance.endTime)
        //             }
        //         }
        //     } 
        //     console.log(this.maintenanceData)
        // },
        // error => {
        //    // bootbox.alert("Something went wrong! Please try again")
        // })

        //Called api to get total FOE score details
        // this.service.get(ConstantComponent.TyreCloudUrl + "/Other/KpiMasterAPI/GetTotalFoeScore/" + ConstantComponent.subscriberIdLogged +"?UserId="+ ConstantComponent.userIdLogged +"&UserSessionId="+ConstantComponent.UserSessionId+"&FormId=0&IpAddress="+ConstantComponent.IpAddress+"&BrowserName="+ConstantComponent.BrowserName+"&BrowserVersion="+ConstantComponent.BrowserVersion).subscribe(data => {            
        //     this.totalFOE=data
        // },
        // (error: AppError) => {
        //     throw error;
        // });

        //Called api to get total fleet score details
        // this.service.get(ConstantComponent.TyreCloudUrl + "/Other/KpiMasterAPI/GetTotalFleetScore/" + ConstantComponent.subscriberIdLogged +"?UserId="+ ConstantComponent.userIdLogged +"&UserSessionId="+ConstantComponent.UserSessionId+"&FormId=0&IpAddress="+ConstantComponent.IpAddress+"&BrowserName="+ConstantComponent.BrowserName+"&BrowserVersion="+ConstantComponent.BrowserVersion).subscribe(data => {                        
        //     this.totalFleet=data
        // },
        // (error: AppError) => {
        //     throw error;
        // });
        
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('push-right');
    }

    rltAndLtr() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('rtl');
    }

    onLoggedout() {
        
        let headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8' });
        let options = new RequestOptions({ headers: headers });
        //Add UserSessionMapping Details in Object
        let UserSessionDetails:any = {};
        UserSessionDetails.UserId = ConstantComponent.userIdLogged;
        UserSessionDetails.UserSessionId = ConstantComponent.UserSessionId;
        UserSessionDetails.FormId = 0;
        UserSessionDetails.IpAddress = ConstantComponent.IpAddress;
        UserSessionDetails.BrowserName = ConstantComponent.BrowserName;
        UserSessionDetails.BrowserVersion = ConstantComponent.BrowserVersion;        

       // this.service.update(ConstantComponent.url + '/UserAPI/LogOut/' + parseInt(localStorage.getItem("userIdLogged")), UserSessionDetails).subscribe((data:any) => {                      
            this.service.update(ConstantComponent.CloudUrl + '/Users/UserAPI/LogOut/' + parseInt(localStorage.getItem("userIdLogged")), UserSessionDetails).subscribe((data:any) => {                      
        if (data.isSuccess == true) {            
            localStorage.clear();
            this.comman.clearLocalStorageOfAllServices()
            //     localStorage.removeItem('isLoggedin');
            // localStorage.removeItem('userAllRights');
            // localStorage.removeItem('SuperAdminRights');
            // localStorage.removeItem('subscriberIdLogged');
            // localStorage.removeItem('usernameLogged');
            // localStorage.removeItem('subscriberNameLogged');
            // localStorage.removeItem('userIdLogged');
            // localStorage.removeItem('financialYearIdLogged');
            // localStorage.removeItem('userRights');
            // localStorage.removeItem('MaintainerRights');
            // localStorage.removeItem('tyreDashboardStatus');
            // localStorage.removeItem('companyName');
            // localStorage.removeItem('token');
            // localStorage.removeItem('tokenExp');
            // localStorage.removeItem('userAccessRights'); // remove user access rights
            // localStorage.removeItem('IsLoginUserSubscriber'); // remove check is login  user subscriber or not
            // //Remove User Session Mapping Details from Local Storage
            // localStorage.removeItem('UserSessionId');
            // localStorage.removeItem('IpAddress');
            // localStorage.removeItem('BrowserName');
            // localStorage.removeItem('BrowserVersion');
            // localStorage.removeItem('ModuleIdClick');// for Dynamic Menu
            // localStorage.removeItem('DynamicMenuList');// for dynamic Menu
            // localStorage.removeItem('UserRoleName');
            // localStorage.removeItem('UserRoleId');
            // localStorage.removeItem('IsTrolleyApplicable');// remove Is Trolley Applicable flag
            // localStorage.removeItem('IsCeatCustomer');// remove Is Ceat Customer flag
        }         
        },
        error => {
            // bootbox.alert("Something went wrong! Please try again")
        })
    }

    showHelplineModal = function (content) {
        this.modalService.open(content).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    os_dropdown = function() {
        $('.os-dropdown-trigger').on('mouseenter', function () {
            $(this).addClass('over');
        });
        $('.os-dropdown-trigger').on('mouseleave', function () {
            $(this).removeClass('over');
        });
    }

    convertTime = function(timeString:string) {
        var nums = timeString.split(':');
        var time
        if(parseInt(nums[0]) > 12) {
            time = (parseInt(nums[0]) - 12) + ':' + nums[1] + "PM" ;
        } else if(parseInt(nums[0]) == 12) {
            time = parseInt(nums[0]) + ':' + nums[1] + "PM" ;
        } else {
            time = parseInt(nums[0]) + ':' + nums[1] + "AM" ;
        }
        return time;
    }

    setDate = function (inputDate) {
        if(inputDate == "") {
            var dtToday = new Date();
        } else {
            var dtToday = new Date(inputDate);
        }
        var month = (dtToday.getMonth() + 1).toString();
        var day = dtToday.getDate().toString();
        var year = dtToday.getFullYear();

        if (dtToday.getMonth() < 9) {
            month = '0' + month.toString();
        }
        if (dtToday.getDate() < 10) {
            day = '0' + day.toString();
        }
        var maxDate = year + '-' + month + '-' + day;
        return maxDate;
    }

    showDemoModal = function async (content) {
        setTimeout(() => {
            console.log(content);
            var that = this;
            this.modalService.open(content, { size: "lg" }).result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                    that.showForgotpassSuccess = false;
                    that.showForgotpassError = false;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(
                        reason
                    )}`;
                    that.showForgotpassSuccess = false;
                    that.showForgotpassError = false;
                }
            );
        }, 300);
    };

    submitChangePasswordRequest(value) {
        console.log(value);
        console.log(this.UserId)
        if(value.confirm_password !== value.new_password){
            bootbox.alert("Please Enter Correct Confirm Password.")
        }else{
            this.service
            .create(
                ConstantComponent.CloudUrl + "/Users/UserAPI/ChangePassword",
                { UserId:localStorage.getItem("userIdLogged"),Password: value.confirm_password }
            )
            .subscribe(
                (data: any) => {
                    console.log(data);
                    if (data.isSuccess) {
                        bootbox.alert("Successfully Changed Password");
                        this.modalService.dismissAll("fogotpasswordsuccess");
                        this.showForgotpassSuccess = true;
                        localStorage.setItem('resetPasswordFlag','false')
                    }
                },
                (error: any) => {
                    console.log("this", error.errors);
                    this.showForgotpassError = true;
                }
            );
        }
        
    }
    validatePassword = (password)=>{
        let pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
        return pattern.test(password)
    }
}
